import { findCompanyBySearchQuery } from "../../../http";

export const findCompanyBySearchTerm = async (searchTerm:string) => {
    try {
        const response = await findCompanyBySearchQuery(searchTerm);
        if(response.status === 200){
            return response?.data?.data;
        }
    } catch (error) {
        throw new Error("Error occured in fetching companies by search term :" + error)
    }
}